enum SourceSystemEnum
{
    EKIS = "EKIS",
}

export default SourceSystemEnum;
